import { useRef, useLayoutEffect } from 'react';
export var useNextFrame = function () {
    var rafIdRef = useRef(null);
    useLayoutEffect(function () {
        if (rafIdRef.current !== null) {
            cancelAnimationFrame(rafIdRef.current);
        }
    }, []);
    return function (task) {
        if (rafIdRef.current !== null) {
            cancelAnimationFrame(rafIdRef.current);
        }
        rafIdRef.current = requestAnimationFrame(function () {
            rafIdRef.current = requestAnimationFrame(function () {
                rafIdRef.current = null;
                task();
            });
        });
    };
};
